export default "__VITE_ASSET__72O6IFuR__"